import { Context, createContext, useContext } from 'react';

export const ModelContext = createContext<unknown | null>(null);

export const useModelContext = (): { model: CF.API.Models.Model; refetchModel: () => void } => {
  const context = useContext<{ model: CF.API.Models.Model; refetchModel: () => void }>(
    ModelContext as Context<{ model: CF.API.Models.Model; refetchModel: () => void }>,
  );
  if (context === null) {
    throw new Error('ModelContext must be used within a ModelContextProvider');
  }
  return context;
};
